<template>
    <form
        :novalidate="true"
        class="FineEmailForm"
        @submit="submitEmail"
    >
        <labelled-input
            :default-value="email"
            :error-label="emailError"
            :is-required="true"
            :label="$t('form:fine:email:label')"
            class="FineRegularization-field FineRegularization-emailField"
            inputType="email"
            @field-value-changed="updateEmail"
        />
        <fine-form-buttons @click-on-back-button="clickOnBackButton" />
    </form>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps } from 'vue'
import LabelledInput from '@/StoreWeb/components/common/LabelledInput'
import FineFormButtons from '@/StoreWeb/components/fine/subcomponent/FineFormButtons'
import formMixins from '@/StoreWeb/js/mixins/form-mixins'
import i18n from 'i18n'

const props = defineProps({
    defaultEmail: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['fineEmail', 'clickOnBackButtonFromFineEmailForm'])

const email = ref('')
const emailError = ref('')

onMounted(() => {
    email.value = props.defaultEmail
})

const updateEmail = (value) => {
    email.value = value
}

const submitEmail = (e) => {
    e.preventDefault()
    clearError()
    let error = false

    if (email.value === '') {
        emailError.value = i18n.global.t('form:error:required_field')
        error = true
    } else if (!formMixins.methods.isMatchingPattern(window.$config.patterns.email, email.value)) {
        emailError.value = i18n.global.t('form:user_infos:email:error:invalid')
        error = true
    }

    if (!error) {
        emit('fineEmail', email.value)
    }
}

const clearError = () => {
    emailError.value = ''
}

const clickOnBackButton = () => {
    emit('clickOnBackButtonFromFineEmailForm')
}
</script>
